import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFolderRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolderRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '84f241b0aad933a3db1f1de11c46deb977e4bed2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1d4a4c9c71cd204fd6dbca057269cf413b5efc20', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a3d21f7a1ef02946ab60653668c61a60f7f09818', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 6h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h4.5v-9h-7.19a.5.5 0 0 1-.44-.28L10 5.5H3.5V9a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 2 9V4.5a.5.5 0 0 1 .5-.5h8.14a.5.5 0 0 1 .49.28zM2 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0m2 .25a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-folder-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolderRemove$1);
            }
            break;
    } });
}

const CosmosIconFolderRemove = CosmosIconFolderRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolderRemove, defineCustomElement };
